import Navbar from "./navBar";
import SectionOne from "./bookingComponents/sectionOne";
import "../css/TeeStyles.css";
import SectionSix from "./sectionSix";
import { ReactElement } from "react";
import SectionTwo from "./bookingComponents/sectionTwo";

const Bookings: React.FC = (): ReactElement => {
  return (
    <>
      <Navbar />
      <main>
        <SectionOne content="Bookings" />
        <SectionTwo />
        <SectionSix />
      </main>
    </>
  );
};
export default Bookings;
